<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-btn icon @click="goBack()">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Shipping Rates</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-container grid-list-lg>
        <v-layout fluid wrap v-if="selectedDestinationCountry && selectedDestinationCountry.countryId === originCity.countryId && selectedDestinationCountry.isValidateCity === '1'">
          <v-flex xs3 md3>
            <v-autocomplete
              prepend-icon="location_on"
              v-model="cboOriginCity"
              :items="originCities"
              item-text="name"
              item-value="cityId"
              label="Origin"
              @change="clickOriginCity(cboOriginCity)"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs3 md2>
            <v-autocomplete
              prepend-icon="location_on"
              v-model="cboDestinationCountry"
              :items="countries"
              item-text="countryName"
              item-value="countryId"
              label="Destination"
              @change="clickCountry(cboDestinationCountry)"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs3 md2>
            <v-autocomplete
              prepend-icon="location_on"
              v-model="cboDestinationProvince"
              :items="provinces"
              item-text="provinceName"
              item-value="provinceId"
              label="Province"
              @change="clickProvince(cboDestinationProvince)"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs3 md3>
            <v-autocomplete
              prepend-icon="location_on"
              v-model="cboDestinationCity"
              :items="cities"
              item-text="cityName"
              item-value="cityId"
              label="City"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md2>
            <v-btn block
              @click="getRates"
            >
              Get Rates
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout fluid wrap v-else-if="selectedDestinationCountry && selectedDestinationCountry.countryId === originCity.countryId && selectedDestinationCountry.isValidateProvince === '1'">
          <v-flex xs4 md3>
            <v-autocomplete
              prepend-icon="location_on"
              v-model="cboOriginCity"
              :items="originCities"
              item-text="name"
              item-value="cityId"
              label="Origin"
              @change="clickOriginCity(cboOriginCity)"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs4 md3>
            <v-autocomplete
              prepend-icon="location_on"
              v-model="cboDestinationCountry"
              :items="countries"
              item-text="countryName"
              item-value="countryId"
              label="Destination"
              @change="clickCountry(cboDestinationCountry)"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs4 md4>
            <v-autocomplete
              prepend-icon="location_on"
              v-model="cboDestinationProvince"
              :items="provinces"
              item-text="provinceName"
              item-value="provinceId"
              label="Province"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md2>
            <v-btn block
              @click="getRates"
            >
              Get Rates
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout fluid wrap v-else>
          <v-flex xs6 md5>
            <v-autocomplete
              prepend-icon="location_on"
              v-model="cboOriginCity"
              :items="originCities"
              item-text="name"
              item-value="cityId"
              label="Origin"
              @change="clickOriginCity(cboOriginCity)"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6 md5>
            <v-autocomplete
              prepend-icon="location_on"
              v-model="cboDestinationCountry"
              :items="countries"
              item-text="countryName"
              item-value="countryId"
              label="Destination"
              @change="clickCountry(cboDestinationCountry)"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md2>
            <v-btn block
              @click="getRates"
            >
              Get Rates
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout fluid wrap>
          <v-flex xs12 class="text-xs-center">
            <v-data-table
              :items="rates"
              hide-actions
              class="elevation-1"
              v-if="rates.length > 0"
            >
              <template slot="headers">
                <tr>
                  <th class="text-xs-center body-2 font-weight-bold">
                    Weight
                  </th>
                  <th v-for="(service, serviceKey) in services" class="text-xs-center body-2 font-weight-bold pt-3 pb-3" :key="serviceKey">
                    {{ service.courierName }}
                    <div class="caption font-weight-regular">{{ service.serviceName }}</div>
                    <div class="caption font-weight-regular">({{ service.minDay }} - {{ service.maxDay }} days)</div>
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <tr :class="(props.index % 2 === 0 ? 'row1' : 'row2')">
                  <td class="text-xs-center">{{ props.item.weight }} kg</td>
                  <td class="text-xs-center" v-for="(rate, rateIndex) in props.item.rates" :key="rateIndex"><span v-if="rate.rate > 0">{{ currencySign }}{{ formatPrice(rate.rate) }}</span><span v-else>-</span><div v-if="rate.packageCount > 1" class="caption grey--text text--darken-1"> ({{ rate.packageCount }} packets)</div></td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
form {
  width: 100%;
}
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import router from '../router'
import axios from 'axios'

export default {
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      drawer: false,
      loading: false,
      def: this.$store.getters.getDef,
      currencyCode: this.$store.getters.getDef.currency.currencyCode,
      currencySign: this.$store.getters.getDef.currency.sign,
      selectedDestinationCountry: {},
      originCity: {},
      cboOriginCity: 'CN-SHENZHEN',
      cboDestinationCountry: '',
      cboDestinationProvince: '',
      cboDestinationCity: '',
      countries: [],
      provinces: [],
      cities: [],
      services: [],
      rates: []
    }
  },

  mounted () {
    this.openDrawerForDesktop()
    this.getCountries()
    this.clickOriginCity(this.cboOriginCity)
  },

  methods: {
    clickOriginCity: function (originCityId) {
      this.rates = []
      this.provinces = []
      this.cities = []
      this.originCity = {}
      this.selectedDestinationCountry = {}
      this.cboDestinationCountry = ''
      this.cboDestinationProvince = ''
      this.cboDestinationCity = ''

      // find origin city
      for (let i in this.originCities) {
        if (this.originCities[i].cityId === originCityId) {
          this.originCity = this.originCities[i]
          break
        }
      }
    },
    clickCountry: function (countryId) {
      this.rates = []
      this.provinces = []
      this.cities = []
      this.selectedDestinationCountry = {}
      this.cboDestinationProvince = ''
      this.cboDestinationCity = ''

      for (let i in this.countries) {
        if (this.countries[i].countryId === countryId) {
          this.selectedDestinationCountry = this.countries[i]
          break
        }
      }

      if (typeof this.selectedDestinationCountry.countryId !== 'undefined') {
        if (this.originCity.countryId === countryId) {
          if (this.selectedDestinationCountry.isValidateProvince === '1') {
            this.getProvinces(countryId)
          }
        }
      } else {
        window.alert('Invalid country: ' + countryId)
      }
    },
    clickProvince: function (provinceId) {
      this.rates = []
      this.cities = []
      this.cboDestinationCity = ''

      if (typeof this.selectedDestinationCountry.countryId !== 'undefined') {
        if (this.selectedDestinationCountry.isValidateCity === '1') {
          this.getCities(provinceId)
        } else {
          this.getRates()
        }
      } else {
        window.alert('Invalid country')
      }
    },
    getCities: function (provinceId) {
      this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/geo/cities/' + provinceId)
        .then(resp => {
          console.log(resp.data)
          this.loading = false
          if (resp.data.status === 'success') {
            this.cities = resp.data.data
          } else {
            window.alert('unable to load cities: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    getProvinces: function (countryId) {
      this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/geo/provinces/' + countryId)
        .then(resp => {
          console.log(resp.data)
          this.loading = false
          if (resp.data.status === 'success') {
            this.provinces = resp.data.data
          } else {
            window.alert('unable to load provinces: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    getCountries: function () {
      var _this = this
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/geo/countries')
        .then(resp => {
          console.log(resp.data)
          if (resp.data.status === 'success') {
            _this.countries = resp.data.data
          } else {
            console.log('unable to load countries: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            } else if (error.response.status === 403) {
              _this.showAlert(error)
            }
          }
        })
    },
    getRates: function () {
      if (this.cboOriginCity.length > 0) {
        if (this.cboDestinationCountry.length > 0) {
          var _this = this
          var url = ''
          if (_this.originCity.countryId === _this.selectedDestinationCountry.countryId && _this.selectedDestinationCountry.isValidateCity === '1') {
            if (_this.cboDestinationCity.length > 0) {
              url = process.env.VUE_APP_API_ROOT + '/v1/shipping/rates/table?max_weight=100&origin_city_id=' + _this.cboOriginCity + '&destination_city_id=' + _this.cboDestinationCity
            } else {
              window.alert('City is required')
              return false
            }
          } else if (_this.originCity.countryId === _this.selectedDestinationCountry.countryId && _this.selectedDestinationCountry.isValidateProvince === '1') {
            if (_this.cboDestinationProvince.length > 0) {
              url = process.env.VUE_APP_API_ROOT + '/v1/shipping/rates/table?max_weight=100&origin_city_id=' + _this.cboOriginCity + '&destination_province_id=' + _this.cboDestinationProvince
            } else {
              window.alert('Province is required')
              return false
            }
          } else {
            url = process.env.VUE_APP_API_ROOT + '/v1/shipping/rates/table?max_weight=100&origin_city_id=' + _this.cboOriginCity + '&destination_country_id=' + _this.cboDestinationCountry
          }

          _this.rates = []
          _this.services = []
          _this.loading = true
          axios.get(url)
            .then(resp => {
              _this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                if (resp.data.data.length > 0) {
                  // map result
                  var i, j, k

                  _this.services = []
                  for (i in resp.data.data) {
                    for (j in resp.data.data[i].services) {
                      _this.services.push({
                        courierId: resp.data.data[i].courierId,
                        courierName: resp.data.data[i].courierName,
                        serviceCode: resp.data.data[i].services[j].serviceCode,
                        serviceName: resp.data.data[i].services[j].serviceName,
                        minDay: resp.data.data[i].services[j].minDay,
                        maxDay: resp.data.data[i].services[j].maxDay
                      })
                    }
                  }

                  _this.rates = []
                  for (i in resp.data.data[0].services[0].rates) {
                    var rates = []
                    for (j in resp.data.data) {
                      for (k in resp.data.data[j].services) {
                        rates.push({
                          rate: resp.data.data[j].services[k].rates[i].rate,
                          packageCount: resp.data.data[j].services[k].rates[i].packageCount
                        })
                      }
                    }
                    _this.rates.push({
                      weight: resp.data.data[0].services[0].rates[i].weight,
                      rates: rates
                    })
                  }
                } else {
                  window.alert('No rate available for selected route')
                }
              } else {
                window.alert('No rate available for selected route: ' + resp.data.message)
              }
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + _this.$route.fullPath)
                } else if (error.response.status === 403) {
                  _this.showAlert(error)
                }
                _this.loading = false
              }
            })
        } else {
          window.alert('Destination is required')
        }
      } else {
        window.alert('Origin is required')
      }
    }
  }
}
</script>
